import { Pipe, PipeTransform } from '@angular/core';
import { IEocnAddress, IPob } from '@lib/interfaces/eocn.interface';

@Pipe({
    standalone: true,
    name: 'eocnPob',
    pure: true,
})
export class EocnPobPipe implements PipeTransform {
    transform(pob: IPob): string {
        return [pob.city, pob.state_province, pob.country].filter(Boolean).join(', ');
    }
}

@Pipe({
    standalone: true,
    name: 'eocnAddress',
    pure: true,
})
export class EocnAddressPipe implements PipeTransform {
    transform(addr: IEocnAddress): string {
        return [addr.street, addr.city, addr.state_province, addr.country, addr.postal_code].filter(Boolean).join(', ');
    }
}

@Pipe({
    standalone: true,
    name: 'eocnAliases',
    pure: true,
})
export class EocnAliasesPipe implements PipeTransform {
    transform(values: string[] | null | undefined): string {
        if (!values?.length) return 'Not available';
        return values.slice(0, 6).join(', ') + (values.length > 6 ? ', etc.' : '');
    }
}
